import type React from 'react';
import { css } from '@/styled-system/css';

export const scrim = css({
  position: 'absolute',
  inset: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.72)',
  // Fallback: browsers without backdrop-filter support see a heavier tint so
  // the scrim still reads as a gate rather than see-through noise.
  '@supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px)))': {
    backgroundColor: 'rgba(255, 255, 255, 0.92)',
  },
  backdropFilter: 'blur(8px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '3x',
  zIndex: 'zIndexOverlay',
  overflowY: 'auto',
});

// Safari 15.4 – 17.x ships backdrop-filter only behind the -webkit- prefix.
// Panda's css() type doesn't include WebkitBackdropFilter; apply it via a
// style attribute instead. Safari 18+ and other browsers ignore this line
// because it doesn't match the unprefixed property they already applied.
export const scrimInlineStyle: React.CSSProperties = {
  WebkitBackdropFilter: 'blur(8px)',
};

export const dialog = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  maxWidth: '28rem',
  gap: '2x',
  backgroundColor: 'hpxWhite',
  borderRadius: '8px',
  padding: '3x',
  boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.12)',
});

export const heading = css({
  fontSize: 'lg',
  fontWeight: 'bold',
  color: 'hpxBlue600',
  margin: 0,
});

export const body = css({
  fontSize: 'md',
  color: 'hpxBlue500',
  margin: 0,
  lineHeight: '1.5',
});

export const incomeList = css({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 'xs',
  fontSize: 'sm',
  color: 'hpxBlue500',
});
